import { render, staticRenderFns } from "./ModalProduct.vue?vue&type=template&id=2a045054&scoped=true"
import script from "./ModalProduct.vue?vue&type=script&lang=ts"
export * from "./ModalProduct.vue?vue&type=script&lang=ts"
import style0 from "./ModalProduct.vue?vue&type=style&index=0&id=2a045054&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a045054",
  null
  
)

export default component.exports